import {
    FC,
    useCallback,
    useEffect,
    useMemo, useRef,
    useState
  } from 'react'
  import {
    TagsSearchModalContainer,
    TagsSearchModalWrapper,
    ModalButton,
    ModalText,
    RingWrapper
  } from './styles'
  import { API, Card, PageModel } from '@brg/api'
  import queryString from 'query-string'
  import { useProfile } from '@brg/auth'
  import { Colors, FlexBox } from '@brg/ui'
  import {NoProjectWrapper} from "./styles";
  import urlApi from 'shared/actions/urlApi'
  import { useTranslation } from 'react-i18next'
  import { Pagination } from 'shared/components/pagination'
  import { ProjectSearchBarSorting } from 'shared/components/projectsSearchBar/components/projectSearchBarSorting'
  import { CompleteTitle } from '../sendProjects/employStyles'
  import { ProjectsCount } from 'shared/pages/ModeratePages/styles'
  import { ShopCard } from 'shared/pages/Shop/ShopCard'
  import { ProjectsGridNew } from 'shared/components/grids'
  import { ModalSearchWrapper } from '../sendProjects/styles'
  import MobileSearchBar from 'shared/components/MobileSearchBar/MobileSearchBar'
  import { SelectRing } from 'shared/components/projectCard/projectCardNew'
  import { useGetCatalogs } from 'shared/hooks/api/useGetCatalogs'
  import EmptyModal from './EmptyModal'
import UsedInProjectModal from './UsedInProjectModal'
import { useGetUserCollections } from 'shared/hooks/api/useGetUserCollections'
  
  interface CollectionsSelectModalProps {
    cardIds: any[]
    projectId: string
    onSubmit: (cards: any[]) => void
  }

  const useGetProjectsWithCollections = () => {
        const [loading, setLoading] = useState<any>(false)
        const [usedCollectionsData, setUsedCalendarsDate] = useState<any>([])
      
        useEffect(() => {
          setLoading(true)
          urlApi()
            //возвращает проекты, в которых прикреплены коллекции
            .getUsedCollectionsIds()
            .then((r) => {
              setUsedCalendarsDate(r)
            })
            .finally(() => setLoading(false))
        }, 
        [])
      
        return {loading, usedCollectionsData}
  }
  
  const CollectionsSelectModal: FC<CollectionsSelectModalProps> = ({
    onSubmit,
    cardIds,
    projectId
  }) => {
    const { i18n } = useTranslation()
    const [selectedCards, setSelectedCards] = useState<any[]>(cardIds || [])
    const [sorting, setSorting] = useState(1)
    const profile = useProfile();
    const { t } = useTranslation();
    const buttonDisabled = !selectedCards?.length || selectedCards?.length !== 1
    const [currentPage, setPage] = useState(1)
    const [searchText, setSearchText] = useState('');
    const scrollRef = useRef<HTMLDivElement>(null)
    const [showAlreadyUsedModal, setShowAlreadyUsedModal] = useState(false)

    const {usedCollectionsData} = useGetProjectsWithCollections()
  
    const scrollTop = () => {
      if (!scrollRef.current) return
      scrollRef.current?.scrollTo(0, 0)
    }
  
    const onClick = useCallback(
      (cardId: string, selected: boolean) => {
       
        if (selected) {
          setSelectedCards(selectedCards.filter((item) => item !== cardId))
          return
        }
        
        setSelectedCards([cardId])
      },
      [selectedCards]
    )
  
    useEffect(() => {
      if (cardIds?.length) {
        setSelectedCards(cardIds)
      }
    } , [cardIds])
  
    const {catalogs, isLoadingCatalogs} = useGetUserCollections('gallery', profile?.accountId || '')
  
    const searchInput = useMemo(() => (
      <ModalSearchWrapper 
        width={'100%'} 
        offsetBottom={24} 
        offsetBottomMobile={16}
      >
        <MobileSearchBar 
          placeholder={t('project_edit.modal.collection.search_placeholder')} 
          onCustomSearch={(data: string) => setSearchText(data)} 
        />
      </ModalSearchWrapper>
  ), [t])
  
    // const cards: Card[] = useMemo(() => {
    //   if (data?.data?.length) {
    //     return data?.data?.map((card) => API.toLang(card, i18n.language))
    //   }
  
    //   return []
    // } , [data, i18n])

    const cards: any[] = useMemo(() => {
      if (catalogs?.length) {
        const filteredCatalogs = catalogs.filter((catalog: any) => !!catalog.card)
        const collectionsData = filteredCatalogs.map((collection: any) => {
          const projectWithCollections = usedCollectionsData.find((project: any) => {
            return project.includedCardCollectionsIds?.includes(collection.cardCollectionId)
          })
          return {...collection, usedInProjectName: projectWithCollections?.title || ''}
        })
        return API.toLang(collectionsData.map((catalog: any) => {
          return {...catalog.card, ...catalog}
        }), i18n.language)
      }


      return []
    }, [catalogs])
  
    const handleAttachClick = () => {
      if (!buttonDisabled) {
        const collectionUsedInProject = selectedCards.filter((collectionId: any) => {
          return !!usedCollectionsData.find((project: any) => {
            return project.includedCardCollectionsIds.includes(collectionId)
          })
        })
        if (collectionUsedInProject.length) {
          setShowAlreadyUsedModal(true)
          return
        }
        onSubmit(selectedCards)
      }
    }

    const cancelAttachment = useCallback(() => {
      setShowAlreadyUsedModal(false)
    }, [])

    const continueAttachment = useCallback(() => {
      onSubmit(selectedCards)
      setShowAlreadyUsedModal(false)
    }, [selectedCards])
  
    return (
      <TagsSearchModalWrapper autoScroll>
        <TagsSearchModalContainer>
          <FlexBox width={'100%'} widthMobile={'100%'} style={{ position: 'relative' }} justify='space-between' justifyMobile='space-between' direction='row' directionMobile="row">
            <FlexBox width={'100%'} widthMobile={'100%'} justify='space-between' align='center' offsetBottom={48}>
              <CompleteTitle>
                {t('project_edit.modal.collection.main_title')}
              </CompleteTitle>
              <ModalButton
                onClick={handleAttachClick}
                fill={Colors.galBlack100}
                disabled={!Boolean(selectedCards?.length)}
                width={250}
              >
                {t('project_edit.modal.collection.add_button')}
              </ModalButton>
            </FlexBox>
          </FlexBox>
          {/* <FlexBox width={'100%'}>
            {searchInput}
          </FlexBox> */}
          { 
          showAlreadyUsedModal? 
            <UsedInProjectModal 
              onSubmit={continueAttachment}
              onCancel={cancelAttachment}
              text={t('project_edit.collection_already_attached')}
            />
          :
          
          cards?.length > 0 || isLoadingCatalogs ? 
          <>
          <FlexBox justify='space-between' offsetBottom={32}>
            <FlexBox align='center' direction='row' directionMobile='row' gx={24}>
              <ModalText>{t('project_edit.modal.collection.choosed_products')}</ModalText>
              <ProjectsCount>{selectedCards?.length}</ProjectsCount>
            </FlexBox>
  
            {/* <ProjectSearchBarSorting
              selectedSorting={sorting}
              onSortingChange={setSorting}
              sortingMethods={[1, 20]}
            /> */}
          </FlexBox>
              <ProjectsGridNew k={20} isFixedHeight isLoading={isLoadingCatalogs} columns={4} mobileColumns={2}>
                {cards?.map((value: any) => {
                  const selected = selectedCards.includes(value?.cardCollectionId)
                  const hidePrice = value?.typeCard !== 'product';
                  const isPrivate = typeof value?.privacyType === 'string' && value.privacyType.toLowerCase() === 'private'
                  console.log('value', value)
                  return (
                    <ShopCard
                      isModalGood
                      customClick={() => {
                        if (isPrivate) {
                          return
                        }
                        onClick(value?.cardCollectionId, selected)
                      }}
                      selected={selected}
                      key={value?.cardCollectionId}
                      card={value}
                      images={value?.images}
                      // price={value?.priceInfo?.realProductPrice}
                      name={`${value?.referenceCollectionName? value?.referenceCollectionName + ' / ' : ''}${value?.name || value?.collectionName}`}
                      hidePrice={hidePrice}
                      usedInProjectName={value.usedInProjectName}
                      isPrivateCollection={isPrivate}
                      selectedComponent={
                        <RingWrapper>
                          <SelectRing active={selected}>
                          <div>
                            {selected && (
                              <svg
                                width="12"
                                height="10"
                                viewBox="0 0 12 10"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M1 4.85653L4.62216 8.45739L11.2699 1.83097L10.4389 1L4.62216 6.79545L1.80966
                                              4.02557L1 4.85653Z"
                                  fill="#FEFEFE"
                                  stroke="black"
                                />
                              </svg>
                            )}
                          </div>
                          </SelectRing>
                        </RingWrapper>
                      }
                    />
                  )
                  })
                }
  
              </ProjectsGridNew>
              {/* <Pagination
                pages={data?.paging?.pages ?? 0}
                page={Number(currentPage)}
                onPageChange={(page: any) => {
                  setPage(page)
                  scrollTop()
                }}
                isCanLoadMore={currentPage < (data?.paging?.pages ?? 0)}
              /> */}
            </>
           : (
            <EmptyModal text={t('project_edit.no_collections')} />
          )
        }
        </TagsSearchModalContainer>
      </TagsSearchModalWrapper>
    )
  }
  
  export default CollectionsSelectModal
  import {
    FC,
    useCallback,
    useEffect,
    useMemo, useRef,
    useState
  } from 'react'
  import {
    TagsSearchModalContainer,
    TagsSearchModalWrapper,
    ModalButton,
    ModalText,
    RingWrapper
  } from './styles'
  import { API, Card, PageModel } from '@brg/api'
  import queryString from 'query-string'
  import { useProfile } from '@brg/auth'
  import { Colors, FlexBox } from '@brg/ui'
  import {NoProjectWrapper} from "./styles";
  import urlApi from 'shared/actions/urlApi'
  import { useTranslation } from 'react-i18next'
  import { Pagination } from 'shared/components/pagination'
  import { ProjectSearchBarSorting } from 'shared/components/projectsSearchBar/components/projectSearchBarSorting'
  import { CompleteTitle } from '../sendProjects/employStyles'
  import { ProjectsCount } from 'shared/pages/ModeratePages/styles'
  import { ShopCard } from 'shared/pages/Shop/ShopCard'
  import { ProjectsGridNew } from 'shared/components/grids'
  import { ModalSearchWrapper } from '../sendProjects/styles'
  import MobileSearchBar from 'shared/components/MobileSearchBar/MobileSearchBar'
  import { SelectRing } from 'shared/components/projectCard/projectCardNew'
  import { useGetCatalogs } from 'shared/hooks/api/useGetCatalogs'
  import EmptyModal from './EmptyModal'
import UsedInProjectModal from './UsedInProjectModal'
import { useGetUserCollections } from 'shared/hooks/api/useGetUserCollections'
  
  interface CollectionsSelectModalProps {
    cardIds: any[]
    projectId: string
    onSubmit: (cards: any[]) => void
  }

  const useGetProjectsWithCollections = () => {
        const [loading, setLoading] = useState<any>(false)
        const [usedCollectionsData, setUsedCalendarsDate] = useState<any>([])
      
        useEffect(() => {
          setLoading(true)
          urlApi()
            //возвращает проекты, в которых прикреплены коллекции
            .getUsedCollectionsIds()
            .then((r) => {
              setUsedCalendarsDate(r)
            })
            .finally(() => setLoading(false))
        }, 
        [])
      
        return {loading, usedCollectionsData}
  }
  
  const CollectionsSelectModal: FC<CollectionsSelectModalProps> = ({
    onSubmit,
    cardIds,
    projectId
  }) => {
    const { i18n } = useTranslation()
    const [selectedCards, setSelectedCards] = useState<any[]>(cardIds || [])
    const [sorting, setSorting] = useState(1)
    const profile = useProfile();
    const { t } = useTranslation();
    const buttonDisabled = !selectedCards?.length || selectedCards?.length !== 1
    const [currentPage, setPage] = useState(1)
    const [searchText, setSearchText] = useState('');
    const scrollRef = useRef<HTMLDivElement>(null)
    const [showAlreadyUsedModal, setShowAlreadyUsedModal] = useState(false)

    const {usedCollectionsData} = useGetProjectsWithCollections()
  
    const scrollTop = () => {
      if (!scrollRef.current) return
      scrollRef.current?.scrollTo(0, 0)
    }
  
    const onClick = useCallback(
      (cardId: string, selected: boolean) => {
       
        if (selected) {
          setSelectedCards(selectedCards.filter((item) => item !== cardId))
          return
        }
        
        setSelectedCards([cardId])
      },
      [selectedCards]
    )
  
    useEffect(() => {
      if (cardIds?.length) {
        setSelectedCards(cardIds)
      }
    } , [cardIds])
  
    const {catalogs, isLoadingCatalogs} = useGetUserCollections('gallery', profile?.accountId || '')
  
    const searchInput = useMemo(() => (
      <ModalSearchWrapper 
        width={'100%'} 
        offsetBottom={24} 
        offsetBottomMobile={16}
      >
        <MobileSearchBar 
          placeholder={t('project_edit.modal.collection.search_placeholder')} 
          onCustomSearch={(data: string) => setSearchText(data)} 
        />
      </ModalSearchWrapper>
  ), [t])
  
    // const cards: Card[] = useMemo(() => {
    //   if (data?.data?.length) {
    //     return data?.data?.map((card) => API.toLang(card, i18n.language))
    //   }
  
    //   return []
    // } , [data, i18n])

    const cards: any[] = useMemo(() => {
      if (catalogs?.length) {
        const filteredCatalogs = catalogs.filter((catalog: any) => !!catalog.card)
        const collectionsData = filteredCatalogs.map((collection: any) => {
          const projectWithCollections = usedCollectionsData.find((project: any) => {
            return project.includedCardCollectionsIds?.includes(collection.cardCollectionId)
          })
          return {...collection, usedInProjectName: projectWithCollections?.title || ''}
        })
        return API.toLang(collectionsData.map((catalog: any) => {
          return {...catalog.card, ...catalog}
        }), i18n.language)
      }


      return []
    }, [catalogs])
  
    const handleAttachClick = () => {
      if (!buttonDisabled) {
        const collectionUsedInProject = selectedCards.filter((collectionId: any) => {
          return !!usedCollectionsData.find((project: any) => {
            return project.includedCardCollectionsIds.includes(collectionId)
          })
        })
        if (collectionUsedInProject.length) {
          setShowAlreadyUsedModal(true)
          return
        }
        onSubmit(selectedCards)
      }
    }

    const cancelAttachment = useCallback(() => {
      setShowAlreadyUsedModal(false)
    }, [])

    const continueAttachment = useCallback(() => {
      onSubmit(selectedCards)
      setShowAlreadyUsedModal(false)
    }, [selectedCards])
  
    return (
      <TagsSearchModalWrapper autoScroll>
        <TagsSearchModalContainer>
          <FlexBox width={'100%'} widthMobile={'100%'} style={{ position: 'relative' }} justify='space-between' justifyMobile='space-between' direction='row' directionMobile="row">
            <FlexBox width={'100%'} widthMobile={'100%'} justify='space-between' align='center' offsetBottom={48}>
              <CompleteTitle>
                {t('project_edit.modal.collection.main_title')}
              </CompleteTitle>
              <ModalButton
                onClick={handleAttachClick}
                fill={Colors.galBlack100}
                disabled={!Boolean(selectedCards?.length)}
                width={250}
              >
                {t('project_edit.modal.collection.add_button')}
              </ModalButton>
            </FlexBox>
          </FlexBox>
          {/* <FlexBox width={'100%'}>
            {searchInput}
          </FlexBox> */}
          { 
          showAlreadyUsedModal? 
            <UsedInProjectModal 
              onSubmit={continueAttachment}
              onCancel={cancelAttachment}
              text={t('project_edit.collection_already_attached')}
            />
          :
          
          cards?.length > 0 || isLoadingCatalogs ? 
          <>
          <FlexBox justify='space-between' offsetBottom={32}>
            <FlexBox align='center' direction='row' directionMobile='row' gx={24}>
              <ModalText>{t('project_edit.modal.collection.choosed_products')}</ModalText>
              <ProjectsCount>{selectedCards?.length}</ProjectsCount>
            </FlexBox>
  
            {/* <ProjectSearchBarSorting
              selectedSorting={sorting}
              onSortingChange={setSorting}
              sortingMethods={[1, 20]}
            /> */}
          </FlexBox>
              <ProjectsGridNew k={20} isFixedHeight isLoading={isLoadingCatalogs} columns={4} mobileColumns={2}>
                {cards?.map((value: any) => {
                  const selected = selectedCards.includes(value?.cardCollectionId)
                  const hidePrice = value?.typeCard !== 'product';
                  const isPrivate = typeof value?.privacyType === 'string' && value.privacyType.toLowerCase() === 'private'
                  console.log('value', value)
                  return (
                    <ShopCard
                      isModalGood
                      customClick={() => {
                        if (isPrivate) {
                          return
                        }
                        onClick(value?.cardCollectionId, selected)
                      }}
                      selected={selected}
                      key={value?.cardCollectionId}
                      card={value}
                      images={value?.images}
                      // price={value?.priceInfo?.realProductPrice}
                      name={`${value?.referenceCollectionName? value?.referenceCollectionName + ' / ' : ''}${value?.name || value?.collectionName}`}
                      hidePrice={hidePrice}
                      usedInProjectName={value.usedInProjectName}
                      isPrivateCollection={isPrivate}
                      selectedComponent={
                        <RingWrapper>
                          <SelectRing active={selected}>
                          <div>
                            {selected && (
                              <svg
                                width="12"
                                height="10"
                                viewBox="0 0 12 10"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M1 4.85653L4.62216 8.45739L11.2699 1.83097L10.4389 1L4.62216 6.79545L1.80966
                                              4.02557L1 4.85653Z"
                                  fill="#FEFEFE"
                                  stroke="black"
                                />
                              </svg>
                            )}
                          </div>
                          </SelectRing>
                        </RingWrapper>
                      }
                    />
                  )
                  })
                }
  
              </ProjectsGridNew>
              {/* <Pagination
                pages={data?.paging?.pages ?? 0}
                page={Number(currentPage)}
                onPageChange={(page: any) => {
                  setPage(page)
                  scrollTop()
                }}
                isCanLoadMore={currentPage < (data?.paging?.pages ?? 0)}
              /> */}
            </>
           : (
            <EmptyModal text={t('project_edit.no_collections')} />
          )
        }
        </TagsSearchModalContainer>
      </TagsSearchModalWrapper>
    )
  }
  
  export default CollectionsSelectModal
  